import React from 'react';
import { useAuth } from '../../hooks/useAuth';

const INK    = '#2B2620';
const WALNUT = '#8B4513';
const MOSS   = '#3B6B44';
const OCHRE  = '#A6752A';
const RUST   = '#A13D2D';
const STONE  = '#8C8275';
const PAPER  = '#FDFBF8';
const FONT_SANS = "'IBM Plex Sans', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif";

export default function UserProfile() {
  const { user } = useAuth();

  const getRoleBadgeColor = (role) => {
    const colors = {
      admin: RUST,
      manager: WALNUT,
      installer: OCHRE,
      office: MOSS
    };
    return colors[role] || STONE;
  };

  if (!user) return null;

  return (
    <div style={{ fontFamily: FONT_SANS }}>
      <h3 style={{
        fontSize: '15px',
        fontWeight: '600',
        color: INK,
        marginBottom: '16px'
      }}>
        Account
      </h3>

      <div style={{
        display: 'flex',
        alignItems: 'center',
        gap: '16px',
        padding: '20px',
        background: PAPER,
        borderRadius: '12px',
        border: '1px solid rgba(139,69,19,0.1)'
      }}>
        {/* Logo/Avatar */}
        <div style={{
          width: '56px',
          height: '56px',
          borderRadius: '12px',
          background: WALNUT,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          fontFamily: "'Fraunces', Georgia, serif",
          fontSize: '24px',
          fontWeight: '700',
          color: 'white',
          flexShrink: 0
        }}>
          {user.name?.charAt(0).toUpperCase() || 'U'}
        </div>

        {/* User Info */}
        <div style={{ flex: 1, minWidth: 0 }}>
          <div style={{
            fontSize: '16px',
            fontWeight: '600',
            color: INK,
            marginBottom: '4px'
          }}>
            {user.name || 'User'}
          </div>

          <div style={{
            fontSize: '13px',
            color: STONE,
            marginBottom: '8px'
          }}>
            {user.email}
          </div>

          {/* Role Badge */}
          <div style={{
            display: 'inline-flex', alignItems: 'center', gap: '6px',
            padding: '4px 12px',
            background: `${getRoleBadgeColor(user.role)}15`,
            borderRadius: '12px',
            fontSize: '12px',
            fontWeight: '600',
            color: getRoleBadgeColor(user.role)
          }}>
            <span style={{ width: '6px', height: '6px', borderRadius: '50%', background: getRoleBadgeColor(user.role) }} />
            {user.role === 'manager' ? 'Office Manager' :
             user.role === 'admin' ? 'Admin' :
             user.role === 'installer' ? 'Install Manager' :
             user.role === 'office' ? 'Office Staff' : user.role}
          </div>
        </div>
      </div>
    </div>
  );
}
